import { Component, OnInit, Input} from '@angular/core';
import { FormGroup} from '@angular/forms';

@Component({
  standalone: false,
  selector: 'app-date-picker',
  templateUrl: './date-picker.component.html',
  styleUrls: ['./date-picker.component.scss']
})
export class DatePickerComponent implements OnInit {

  date: Date;
  centerMonth: Date;
  leftMonth: Date;
  rightMonth: Date;
  _selectedDates: Date[];


  @Input() parentForm: FormGroup;

  @Input()
  set value(property: Date[]) {
    this._selectedDates = property;
  }
  get value():  Date[] { return this._selectedDates; }

  constructor() {
    this.date = new Date();
    this.setMonth(this.date);
  }


  setMonth(date: any): any {
    var currentMonth = new Date(date);
    currentMonth.setDate(1);

    let centerMonth = new Date(currentMonth);
    centerMonth.setMonth(currentMonth.getMonth() + 1);
    this.centerMonth = centerMonth;

    var leftMonth = new Date(currentMonth);
    leftMonth.setMonth(currentMonth.getMonth());
    this.leftMonth = leftMonth;

    var previousMonth = new Date(currentMonth);
    previousMonth.setMonth(currentMonth.getMonth() + 2);
    this.rightMonth = previousMonth;

  }

  backMonth()
  {
    var newDate = new Date(this.date);
    newDate.setMonth(this.date.getMonth()-1);

    this.date = newDate;
    this.setMonth(newDate);
  }

  nextMonth()
  {
    var currDate = new Date()
     var newDate = new Date(this.date);
     newDate.setMonth(newDate.getMonth()+1);

     var timeline = (newDate.getMonth() - currDate.getMonth()) + ((newDate.getFullYear() - currDate.getFullYear()) * 12);

     if(timeline > 12)
      return;

     this.date = newDate;
     this.setMonth(newDate);
  }


  ngOnInit() {
  }



}
